/** StripeInvoiceStatus::VOID. A voided invoice is uncollectable, but it is not paid. */
export const VOID_INVOICE_STATUS_ID = 18;

export interface InvoiceCheckoutMoney {
  status_id: number;
  amount_remaining: number;
}

/**
 * Whether the invoice behind a checkout link has nothing left to collect *because it was
 * paid*.
 *
 * The balance alone cannot answer that: voiding an invoice zeroes amount_remaining too
 * (InvoiceVoidAction), so reading the column on its own tells the client their cancelled
 * invoice was paid. A voided one is not settled — it falls through to the screen that points
 * the client back at the company (FD-7595).
 */
export const isInvoiceSettled = ({ status_id, amount_remaining }: InvoiceCheckoutMoney): boolean =>
  status_id !== VOID_INVOICE_STATUS_ID && amount_remaining <= 0;
